/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase, State } from 'app/shared/lib/essette-site';
import { INotesConfig, ITasksConfig } from 'app/core/models/essette-interfaces';
import { ISmartTaskBinding, ITaskContainer } from 'app/core/components/tasks/task';
import { NotesGrid } from 'app/core/components/notes/notes-grid';
import * as Core from 'app/core/models/essette-api';


/** View-Model for the Note Smart-Task component */
@autoinject()
export class SmartNote extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected task!: Core.Task;
    protected targetId!: string;
    protected tasksConfig: ITasksConfig = {};
    protected notesConfig: INotesConfig = {};

    private container!: ITaskContainer;
    private notesGrid!: NotesGrid;
    protected readonly: boolean = false;


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }

    protected async activate(params: ISmartTaskBinding): Promise<void> {
        if(!params || !params.container || !params.targetId || !params.task || !params.task.id || !params.tasksConfig || !params.tasksConfig.smartTasksConfig || !params.tasksConfig.smartTasksConfig.notesConfig) {
            throw TypeError(`${SmartNote.name} Component Model not Bound.`);
        }

        const argumentId = params.task.definition?.type?.argument?.id || undefined;

        this.targetId = params.targetId;
        this.tasksConfig = params.tasksConfig;

        // copy notes config from smart tasks config
        this.notesConfig = {
            ...params.tasksConfig.smartTasksConfig.notesConfig,
            taskId: params.task.id,
            categoryId: argumentId,
            excludeSystem: false
        };

        this.state = params.state || this.state;

        this.task = params.task;
        this.container = params.container;
        this.readonly = params.readonly;
    }


    ////****************** Events ***************************************************////
    protected saveNoteSuccess(): void {
        if(this.container) {
            this.notesGrid.reload(true);
            this.container.completeTask(true);
        }
    }


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////

}
